import { CircularProgress } from '@mui/material';
import './Loading.scss';

export default function Loading() {
  return (
    <div className='loading-wrapper'>
      <CircularProgress color='primary' />
    </div>
  );
}